module.exports = __webpack_public_path__ + "static/media/spacex3.8294e874.png";